import { Box, Grid, Typography as TypoGraphy } from '@mui/material';
import React from 'react';

import { ArticleItem } from '../../blogPage/Articles/ArticleItem';
import type { Article } from '../../blogPage/Articles/Articles.types';
import { classes, LatestArticleWrapper } from './LatestArticles.styles';
import type { LatestArticlesProps } from './LatestArticles.types';

export const LatestArticles: React.FC<LatestArticlesProps> = ({
  latestBlogPosts,
}) => {
  return (
    <LatestArticleWrapper>
      <div className={classes.root}>
        <Box>
          <TypoGraphy className={classes.title} variant="h2" align="center">
            Recent posts
          </TypoGraphy>
        </Box>
        <Grid
          className={classes.container}
          px={4}
          container
          direction="row"
          justifyContent="center"
          maxWidth={1400}
          spacing={{
            xs: 0,
            md: 4,
          }}>
          {latestBlogPosts.map((article) => (
            <ArticleItem
              article={article as unknown as Article}
              key={article.documentId}
            />
          ))}
        </Grid>
      </div>
    </LatestArticleWrapper>
  );
};
